import React, { useEffect, useContext, createRef } from "react";
import styled from "styled-components";

import { handleSendMsg } from "../actions";
import SocketService from "../../../../service/socket";
import { SocketStateContext } from "../../../../provider";

import { Col, Box, Row, Text, InputBox, SearchBox } from "../../../../comps";
import { Theme } from "../../../../theme/theme-provider";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
`;

const MessagesWrapper = styled(Col)`
  width: 100%;
  height: calc(100% - 50px);
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0px;
  }
  &:hover {
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.color.GRAY_2};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.color.GRAY_1};
      border-radius: 20px;
    }
  }
`;

const InputWrapper = styled(Box)`
  width: 100%;
  margin-top: 10px;
  height: 40px;
`;

const MsgWrapper = styled(Row)`
  width: 100%;
  align-items: center;
`;

const TextContainer = styled(Col)`
  max-width: 90%;
  min-width: 30%;
  margin-top: 8px;
  background: ${({ theme }) => theme.color.BLACK_1};
  border-radius: 3px;
`;

const Message = ({ message: { username, msg }, idx }) => {
  return (
    <MsgWrapper>
      <TextContainer>
        <Text
          fontSize="14px"
          fontWeight="560"
          marginLeft="8px"
          marginTop="2px"
          color={Theme.color.GRAY_1}
        >
          {username}
        </Text>
        <Text
          marginLeft="8px"
          marginRight="12px"
          marginTop="4px"
          marginBottom="5px"
          fontSize="14px"
          color={Theme.textColor.light}
          oneline={false}
        >
          {msg}
        </Text>
      </TextContainer>
    </MsgWrapper>
  );
};

export default ({ roomInfo }) => {
  const [socketInfo] = useContext(SocketStateContext);
  const { id } = roomInfo;
  let messages = [];
  const room = socketInfo[id];
  if (room) messages = room["chats"];
  const inputId = "id_54g5input";
  const refMessages = createRef();

  useEffect(() => {
    const inputBox = document.getElementById(inputId);
    if (inputBox)
      inputBox.addEventListener("keyup", function (event) {
        event.preventDefault();
        if (event.keyCode === 13) {
          sendMessage();
        }
      });
  }, []);

  useEffect(() => {
    const ele = refMessages.current;
    ele.scrollTo(0, ele.scrollHeight);
  }, [refMessages]);

  const sendMessage = async () => {
    const inputBox = document.getElementById(inputId);
    if (!inputBox) return;
    const val = inputBox.value;
    const done = await handleSendMsg({ msg: val, roomInfo });
    if (done) inputBox.value = null;
  };

  return (
    <Wrapper>
      <MessagesWrapper ref={refMessages}>
        {messages &&
          messages.map((message, idx) => {
            return <Message key={idx} message={message} idx={idx} />;
          })}
      </MessagesWrapper>
      <InputWrapper>
        <SearchBox
          textColor={Theme.textColor.light}
          placeholder="Type your message..."
          textAlign="left"
          inputId={inputId}
          fontSize="16px"
          background={Theme.color.BLACK_0}
          buttonTextColor={Theme.textColor.light}
          buttonBackground={Theme.color.BLUE_4}
          buttonName="Send"
          buttonIcon={faPaperPlane}
          buttonRatio={30}
          buttonFontSize="16px"
          onClick={() => {
            sendMessage();
          }}
        />
      </InputWrapper>
    </Wrapper>
  );
};
